import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { GridColumn, GridRow } from "arv-reactcomponents";

import { generateDateFormatFromSystemDate } from "../../../utils";
import { ORDERDETAILS } from "npmlinks-constants";

const { ORDER_DETAILS } = ORDERDETAILS;
const {
  ORDER_SUMMARY: {
    ORDERED_ON,
    STATUS,
    ORDER_NUMBER,
    PRODUCTS,
    PAYMENT_METHOD,
    TITLE,
  },
} = ORDER_DETAILS;

class OrderSummary extends PureComponent {
  get totalCount() {
    const { orderDetails: { consignments } } = this.props;
    let totalCount = 0;
    if (consignments) {
      consignments.forEach(consignment => {
        const itemCount = (consignment.items && consignment.items.length) || 0;
        totalCount += itemCount;
      });
    }
    return totalCount || null;
  }
  get orderedOn() {
    const { orderDate } = this.props.orderDetails;
    return generateDateFormatFromSystemDate(orderDate);
  }

  render() {
    const { orderDetails } = this.props;
    const {
      orderDate = "",
      orderId = "",
      orderStatus = "",
      paymentMethod = "",
    } = orderDetails;
    return (
      <Fragment>
        <GridRow className="nw-ordersummary-content">
          <GridColumn className="nwc-grid-col-xs nw-ordersummary-unit">
            <div className="nw-ordersummary-subtitle">{ORDERED_ON}</div>
            <div>{this.orderedOn}</div>
          </GridColumn>
          <GridColumn className="nwc-grid-col-xs nw-ordersummary-unit">
            <div className="nw-ordersummary-subtitle">{STATUS}</div>
            <div>{orderStatus}</div>
          </GridColumn>
          <GridColumn className="nwc-grid-col-xs nw-ordersummary-unit">
            <div className="nw-ordersummary-subtitle">{ORDER_NUMBER}</div>
            <div>{orderId}</div>
          </GridColumn>
          <GridColumn className="nwc-grid-col-xs nw-ordersummary-unit">
            <div className="nw-ordersummary-subtitle">{PRODUCTS}</div>
            <div>{this.totalCount}</div>
          </GridColumn>
          <GridColumn className="nwc-grid-col-xs nw-ordersummary-unit">
            <div className="nw-ordersummary-subtitle">{PAYMENT_METHOD}</div>
            <div>{paymentMethod}</div>
          </GridColumn>
          <GridColumn className="nwc-grid-col-xs nw-ordersummary-unit" />
        </GridRow>
      </Fragment>
    );
  }
}

OrderSummary.defaultProps = {
  orderDetails: {
    orderDate: "",
    orderId: "",
    orderStatus: "",
    consignments: [],
    paymentMethod: "",
  },
};

OrderSummary.propTypes = {
  orderDetails: PropTypes.shape({
    orderDate: PropTypes.string,
    orderId: PropTypes.string,
    orderStatus: PropTypes.string,
    consignments: PropTypes.arrayOf(PropTypes.object),
    paymentMethod: PropTypes.string,
  }),
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: OrderSummary,
  component: OrderSummary,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderDetailsComponents/OrderSummary/index.js